module.exports = __webpack_public_path__ + "img/position_AM.47422ad8.png";